import type { HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './Container.module.css';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

export function Container({ size = 'md', className, ...rest }: ContainerProps) {
  return <div className={clsx(styles.container, styles[size], className)} {...rest} />;
}
